"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkLine = void 0;
const characteristics_1 = __importDefault(require("./characteristics"));
const constants_1 = require("./constants");
const number_1 = require("../utils/number");
const array_1 = require("../utils/array");
const characteristics_2 = require("../@types/characteristics");
function checkLine(line, lineCharacteristic) {
    const { split, columns, columnCount, startsWith, endsWith, content, exclude } = lineCharacteristic;
    const lineMatchConditions = [];
    if (split) {
        line = line.trim();
        const items = line.split(split);
        columnCount &&
            (columnCount instanceof Array
                ? lineMatchConditions.push(columnCount.includes(items.length))
                : lineMatchConditions.push(items.length === columnCount));
        if (columns) {
            for (let index in columns) {
                const item = items[index];
                const column = columns[index];
                constants_1.strandFlags[column] &&
                    lineMatchConditions.push(constants_1.strandFlags[column].includes(item));
                if (!constants_1.numberColumnsSet.has(column))
                    continue;
                lineMatchConditions.push((0, number_1.isNumber)(item));
            }
        }
    }
    if (startsWith) {
        lineMatchConditions.push(line.startsWith(startsWith));
    }
    if (endsWith) {
        lineMatchConditions.push(line.endsWith(endsWith));
    }
    if (content) {
        Array.from(content).forEach(contentString => {
            lineMatchConditions.push(line.indexOf(contentString) >= 0);
        });
    }
    if (exclude) {
        const lineCharacteristicExclude = exclude;
        lineMatchConditions.push(!checkLine(line, lineCharacteristicExclude));
    }
    return (0, array_1.allTrue)(lineMatchConditions);
}
exports.checkLine = checkLine;
function checkTypeByHeadLines(headLines) {
    for (const alignType in characteristics_1.default) {
        if (alignType === characteristics_2.AlignType.UNKNOWN)
            continue;
        const characteristic = characteristics_1.default[alignType];
        const matchConditions = [];
        if (characteristic.all) {
            headLines.forEach((line) => {
                matchConditions.push(checkLine(line, characteristic.all));
            });
        }
        if (characteristic.include) {
            characteristic.include.forEach(lineCharacteristic => {
                const matchCondition = headLines.findIndex(line => checkLine(line, lineCharacteristic)) > 0;
                matchConditions.push(matchCondition);
            });
        }
        if ((0, array_1.allTrue)(matchConditions)) {
            return alignType;
        }
    }
    return characteristics_2.AlignType.UNKNOWN;
}
exports.default = checkTypeByHeadLines;
